'use strict';

import ItemView from './PayrollItem.js';
import ListEditablesView from 'commons/views/ListEditables.js';
import modal from 'helpers/modal';
import PayrollItemIntegration from 'newModels/payroll-item-integration.js';
import template from
    '../../../../templates/settings/integrations/xero/PayrollItems.ejs';
import PayrollItemSelectionModal from
    'employer/views/PayrollItemSelectionModal.js';

module.exports = ListEditablesView.extend({
    modelViews: [],
    modalView: null,

    events: function() {
        var parentEvents = _.isFunction(ListEditablesView.prototype.events) ?
            ListEditablesView.prototype.events() :
            ListEditablesView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-add-items': 'showSelectModal',
            'click .js-show-all-items': 'addAllItems',
            'click .js-hide-unmapped-items': 'destroyUnmappedItems',
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            Model: PayrollItemIntegration,
            ModelView: ItemView,
            mappableItems: null,
        });

        this.options.templateExtra = {
            mappingType: this.options.mappingType,
            debitAccounts: this.options.debitAccounts,
            creditAccounts: this.options.creditAccounts,
            contacts: this.options.contacts,
        };

        this.integration = options.integration;
        this.mappingType = this.options.mappingType;
        this.mappingTypeMap = {
            'net': [
                'Net Salary',
                'PCB',
                'PCB borne by employer',
                'EPF (Employee)',
                'EPF (Employer)',
                'SOCSO (Employee)',
                'SOCSO (Employer)',
                'EIS (Employee)',
                'EIS (Employer)',
                'HRDF',
                'ZAKAT',
            ],
            'base': [
                'Basic Salary',
                'PCB',
                'PCB borne by employer',
                'EPF (Employee)',
                'EPF (Employer)',
                'SOCSO (Employee)',
                'SOCSO (Employer)',
                'EIS (Employee)',
                'EIS (Employer)',
                'HRDF',
                'ZAKAT'
            ],
            'gross': [
                'Gross Salary',
                'PCB',
                'PCB borne by employer',
                'EPF (Employee)',
                'EPF (Employer)',
                'SOCSO (Employee)',
                'SOCSO (Employer)',
                'EIS (Employee)',
                'EIS (Employer)',
                'HRDF',
                'ZAKAT'
            ],
        };

        this.mapping = this.mappingTypeMap[this.mappingType];

        // for adding new payroll items such as additions/deductions
        this.unmappedItems = this.options.mappableItems.clone();
        this.updateItemAvailability();
        this.payrollItemsModal = new PayrollItemSelectionModal({
            collection: this.unmappedItems
        });

        return ListEditablesView.prototype.initialize.apply(
            this, [this.options]
        );
    },

    getFormState: function() {
        // check weather the form is empty or just partially done
        // partial example is when we add contact but not account
        // or vice versa
        let isEmpty = true;
        let isPartial = false;
        for (let i = 0; i < this.filteredCollection.length; ++i) {
            const item = this.filteredCollection[i];
            const hasAccount =
                !!item.get('debitAccount') && !!item.get('creditAccount');
            const hasContact = !!item.get('contact');

            if (hasAccount && hasContact) {
                isEmpty = false;
            } else if (!hasAccount && !hasContact) {
                // dont have nothing
            } else {
                isPartial = true;
            }

            // wall case, cannot change anymore
            if (!isEmpty && isPartial) {
                break;
            }
        }

        return {
            isEmpty,
            isPartial
        };
    },

    isDirty: function() {
        const tainted = this.modelViews.filter(m => m.tainted);
        return tainted.length > 0;
    },

    bindHandlers: function() {
        this.payrollItemsModal.on('select', this.addItems, this);

        this.collection.on(
            'add remove reset', this.updateItemAvailability, this);

        this.collection.on('remove', this.removeModelView, this);

        app.events.on('navigate', function(status) {
            if (this.isDirty()) {
                status.unsaved = true;
                status.msg     = 'You have unsaved changes.  Exiting this ' +
                    'page will result in the changes being discarded.';
            } else {
                status.unsaved = false;
            }
        }, this);

        app.events.on('hard-exit', this.hardExit, this);

        return ListEditablesView.prototype.bindHandlers.apply(this, arguments);
    },

    unbindHandlers: function() {
        return ListEditablesView.prototype.bindHandlers.apply(this, arguments);
    },

    renderModels: function() {
        if (!this.options.ModelView) {
            return this;
        }

        this.removeModelViews();

        if (!this.collection) {
            return this;
        }

        // filter collections based on mapping type
        // very big problem for basic type since there are
        // custom elementts also...
        this.filteredCollection = this.collection.filter(c =>
            this.mapping.indexOf(c.get('label')) > -1 ||
            (this.mappingType === 'base' && c.get('isCustom')));

        // eliminate duplicate payrollitems to avoid sync problems
        // only applicable to 'base' mapping type
        if (this.mappingType === 'base') {
            const uniques = [];
            this.filteredCollection = this.filteredCollection.filter(c => {
                const payrollItemId = c.get('payrollItemId');

                if (uniques.indexOf(payrollItemId) > -1) {
                    return false;
                }

                uniques.push(payrollItemId);
                return true;
            });
        }

        // sort filteredCollection by index
        this.filteredCollection.sort((x, y) =>
            x.get('index') - y.get('index'));

        this.filteredCollection.forEach(model => {
            this.renderModel(model);
        });

        return this;
    },

    renderModel: function(model) {
        var view = new this.options.ModelView({
            model: model,
            debitAccounts: this.options.debitAccounts,
            creditAccounts: this.options.creditAccounts,
            contacts: this.options.contacts,
            mappingType: this.mappingType,
            mapping: this.mapping,
        });

        this.$('.js-model-views').append(view.$el);
        this.modelViews.push(view);
        return this;
    },

    showSelectModal: function(e) {
        e.preventDefault();

        this.payrollItemsModal.show();
    },

    addItems: function(payrollItems) {
        payrollItems.forEach(payrollItem => {
            this.collection.add({
                companyId: app.company.id,
                integrationId: this.options.integration.id,
                payrollItemId: payrollItem.id,
                affects: payrollItem.get('type'),
                employee: false,
                label: payrollItem.get('name'),
                index: this.collection.length + 1,
                isCustom: true,
                debitAccount: null,
                creditAccount: null,
                contact: null,
            }, {silent: true});
        });

        this.renderModels();
    },

    addAllItems: function(e) {
        e.preventDefault();

        this.addItems(this.unmappedItems);
    },

    destroyUnmappedItems: function(e) {
        e.preventDefault();

        const unmapped = this.collection.filter(model => {
            const isMissingProperty =
                !model.get('debitAccount') ||
                !model.get('creditAccount') ||
                !model.get('contact');
            const isCustom = model.get('isCustom') || false;

            return isMissingProperty && isCustom;
        });

        unmapped.forEach(model => this.collection.remove(model));
    },

    updateItemAvailability: function() {
        this.unmappedItems.reset(
            this.options.mappableItems.clone().filter(model => {
                return !this.collection.find(itemIntegration => {
                    let itemId = itemIntegration.get('payrollItemId');
                    return (itemId === model.id);
                });
            })
        );
    },

    save: function(ev) {
        const formState = this.getFormState();

        if (formState.isPartial) {
            this.integration.set('ready', false);
            this.integration.save()
                .then(() =>
                    modal.showError(
                        'You must assign debit/credit account and contact to ' +
                        'payroll item in order for sync to work properly!',
                        false
                    )
                );

            return false;
        }

        if (formState.isEmpty) {
            this.integration.set('ready', false);
            this.integration.save()
                .then(() =>
                    modal.showError(
                        'Contact field is required to be mapped',
                        false
                    )
                );

            return false;
        }

        this.integration.set('ready', true).save()
            .then(() =>
                ListEditablesView.prototype.save.apply(this, [ev])
                    .then(() =>
                        modal.showAlertSuccess('Mappings have been saved')
                    )
            );

        return false;
    },

    removeModelView: function(model) {
        let view = _(this.modelViews).find(v => v.model.cid === model.cid);

        if (!view) {
            return;
        }

        view.remove();
        view = null;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/integrations/xero/PayrollItems.js